import { Percomatic } from '@biggby-coffee/percomatic-typescript';
import { useRecoilState, useRecoilValue } from 'recoil';

import { ModifierScaleSelector } from '../ModifierScaleSelector';
import { activeModifierScaleState, modifyingState } from '../../atoms';
import {
	useIncreaseModifierLevel,
	useDecreaseModifierLevel
} from '../../hooks/api';
import { Option } from '../../../components/Option';
import { QuantityControl } from '../../../components/QuantityControl';

export type ModifierScaleProps = {
	modifierScaleIndex: number;
	isActive: boolean;
	modifierScale: Percomatic.Serialized.ModifierScale;
	selectedIndex: number;
};

export const ModifierScale: React.FC<ModifierScaleProps> = ({
	modifierScaleIndex,
	modifierScale,
	selectedIndex,
	isActive
}) => {
	const modifying = useRecoilValue(modifyingState);
	const increaseModifierLevel = useIncreaseModifierLevel();
	const decreaseModifierLevel = useDecreaseModifierLevel();
	const [activeModifierScale, setActiveModifierScale] = useRecoilState(
		activeModifierScaleState
	);

	const modifiers = modifierScale.modifiers;
	const scaleSelected = modifierScale.modifiers[selectedIndex];
	const scaleName = modifierScale.name;

	let body;

	if (modifiers.flatMap(modifier => modifier.name.split('')).length < 40) {
		body = (
			<ModifierScaleSelector
				modifiers={modifiers}
				selectedIndex={selectedIndex}
				clickHandler={(index: number) => {
					if (!modifying) {
						const times = index - selectedIndex;

						if (times > 0) {
							increaseModifierLevel(times, modifierScaleIndex);
						} else if (times < 0) {
							decreaseModifierLevel(
								Math.abs(times),
								modifierScaleIndex
							);
						}
					}
				}}
			/>
		);
	} else {
		body = (
			<div className="w-100 w-xs-75 w-sm-50 w-lg-75 w-xl-50 mx-auto">
				<QuantityControl
					name={scaleName}
					quantity={scaleSelected.name}
					margins={3}
					size="large"
					color="primary"
					fontColor="light"
					increment={() => {
						if (!modifying) {
							if (selectedIndex < modifiers.length - 1) {
								increaseModifierLevel(1, modifierScaleIndex);
							}
						}
					}}
					decrement={() => {
						if (!modifying) {
							if (selectedIndex > 0) {
								decreaseModifierLevel(1, modifierScaleIndex);
							}
						}
					}}
				/>
			</div>
		);
	}

	return (
		<div className="product-modifier-scale">
			<Option
				isActive={isActive}
				header={{
					name: scaleName,
					left: scaleName,
					right: scaleSelected.name,
					onClick() {
						if (activeModifierScale === modifierScaleIndex) {
							setActiveModifierScale(-1);
						} else {
							setActiveModifierScale(modifierScaleIndex);
						}
					}
				}}
			>
				{body}
			</Option>
		</div>
	);
};
